import { ifAuthenticated } from '@/router/before'

export const requestsRouteNames = {
  AuthorRequestsRoute: 'AuthorRequestsRoute',
  EditorRequestsRoute: 'EditorRequestsRoute',
  NotificationsRequestsRoute: 'NotificationsRequestsRoute'
}
const rn = requestsRouteNames

export const requestsRouteURLs = {
  [rn.AuthorRequestsRoute]: '/requests/author',
  [rn.EditorRequestsRoute]: '/requests/editor',
  [rn.NotificationsRequestsRoute]: '/requests/notifications'
}

export const requestsPages = [
  {
    path: requestsRouteURLs[rn.AuthorRequestsRoute],
    name: rn.AuthorRequestsRoute,
    meta: {
      sidebar: {
        icon: ['fas', 'clipboard-list'],
        isDisplay: true
      },
      navbar: {
        group: 'Заявки на оплату публикаций',
        displayName: 'Подача заявок'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "AuthorRequestsRoute" */ '@/views/requests/AuthorRequestsRoute.vue'
      )
  },
  {
    path: requestsRouteURLs[rn.EditorRequestsRoute],
    name: rn.EditorRequestsRoute,
    meta: {
      sidebar: {
        icon: ['fas', 'calendar-check'],
        isDisplay: true
      },
      navbar: {
        group: 'Заявки на оплату публикаций',
        displayName: 'Обработка заявок'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "EditorRequestsRoute" */ '@/views/requests/EditorRequestsRoute.vue'
      )
  },
  {
    path: requestsRouteURLs[rn.NotificationsRequestsRoute],
    name: rn.NotificationsRequestsRoute,
    meta: {
      sidebar: {
        icon: ['fa', 'envelope'],
        isDisplay: true
      },
      navbar: {
        group: 'Заявки на оплату публикаций',
        displayName: 'Закрытие приема заявок'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "ServiceNotificationsRoute" */ '@/views/requests/ServiceNotificationsRoute.vue'
      )
  }
]
